module.exports = __webpack_public_path__ + "img/title-zh.888a66c5.png";